// extracted by mini-css-extract-plugin
export var pillTrigger = "_64-0";